import {
  PRIMARY_SIGN_UP_METHOD,
  LOGIN_EDITABLE,
  LOGIN_OPTIONAL,
  SECOND_CONTACT_CONFIG,
  SECOND_CONTACT_EDITABLE,
  SECOND_CONTACT_HIDE_OTP,
} from './Config';

// simplify login or contact method settings
export const MOBILE_AND_EMAIL_BOTH_FOR_SIGN_UP = PRIMARY_SIGN_UP_METHOD === "MOBILE_PHONE_NUMBER_AND_EMAIL_ADDRESS";
export const SECOND_CONTACT_SHOW = ["MANDATORY", "OPTIONAL"].includes(SECOND_CONTACT_CONFIG);
export const SECOND_CONTACT_OPTIONAL = SECOND_CONTACT_CONFIG === "OPTIONAL";

export const LOGIN_SHOW_EDIT_BUTTON = ["EDITABLE", "CONTACT_CUSTOMER_SERVICE"].includes(LOGIN_EDITABLE);
export const LOGIN_SHOW_CUSTOMER_SERVICE = LOGIN_EDITABLE === "CONTACT_CUSTOMER_SERVICE";
export const SECOND_CONTACT_SHOW_EDIT_BUTTON = ["EDITABLE", "CONTACT_CUSTOMER_SERVICE"].includes(SECOND_CONTACT_EDITABLE);
export const SECOND_CONTACT_SHOW_CUSTOMER_SERVICE = SECOND_CONTACT_EDITABLE === "CONTACT_CUSTOMER_SERVICE";

const checkEditMobileOptional = () => {
  // mobile as only sign up method
  if (PRIMARY_SIGN_UP_METHOD === "MOBILE_PHONE_NUMBER") {
    return false;
  };
  // mobile as sign up method and is optional
  if (PRIMARY_SIGN_UP_METHOD === "MOBILE_PHONE_NUMBER_AND_EMAIL_ADDRESS" && LOGIN_OPTIONAL) {
    return true;
  };
  // mobile as contact method and is optional
  if (PRIMARY_SIGN_UP_METHOD === "EMAIL_ADDRESS" && SECOND_CONTACT_OPTIONAL) {
    return true;
  };
  return false;
};
export const EDIT_MOBILE_OPTIONAL = checkEditMobileOptional();

const checkEditEmailOptional = () => {
  // email as only sign up method
  if (PRIMARY_SIGN_UP_METHOD === "EMAIL_ADDRESS") {
    return false;
  };
  // email as sign up method and is optional
  if (PRIMARY_SIGN_UP_METHOD === "MOBILE_PHONE_NUMBER_AND_EMAIL_ADDRESS" && LOGIN_OPTIONAL) {
    return true;
  };
  // email as contact method and is optional
  if (PRIMARY_SIGN_UP_METHOD === "MOBILE_PHONE_NUMBER" && SECOND_CONTACT_OPTIONAL) {
    return true;
  };
  return false;
};
export const EDIT_EMAIL_OPTIONAL = checkEditEmailOptional();
